<template>
  <div v-loading="isLoading">
    <rest-form-item
      prop="params.mapping"
      style="display: none"
    ></rest-form-item>
    <rest-form-item
      prop="params.enabledDataExtensions"
      style="display: none"
    ></rest-form-item>
    <rest-form-item prop="params" style="display: none"></rest-form-item>
    <add-data-extension-dialog v-if="showDialog" :model="model" />
    <el-card class="form-section" shadow="never">
      <div
        class="DataExtensionsList__Empty"
        v-if="
          !model.params.hasOwnProperty('enabledDataExtensions') ||
            model.params.enabledDataExtensions.length === 0
        "
      >
        <span class="DataExtensionsListEmpty__Warning">
          {{ $t('Integrations_Salesforce_DataMappingWarning') }}
        </span>
        <el-button type="primary" @click="addDataExtension">
          {{ $t('Integrations_Salesforce_DataMapping_AddDataExtension') }}
        </el-button>
      </div>
      <div class="DataExtensionsList" v-else>
        <div v-if="!model.id" class="DataExtensionsList--Controls">
          <el-button type="primary" @click="addDataExtension">
            {{ $t('Integrations_Salesforce_DataMapping_AddDataExtension') }}
          </el-button>
        </div>
        <data-extension-mapping
          ref="de_mapping"
          v-for="extension in paginatedExtensions"
          :key="extension.dataExtensionName"
          :extension-name="extension.dataExtensionName"
          :model="model"
          @mappingChanged="mappingChanged"
          @removeDataExtension="removeDataExtension"
        />
        <el-pagination
          v-if="pagination"
          background
          class="paginator"
          :layout="'prev, pager, next'"
          :page-count="totalPages"
          :current-page="currentPage"
          :page-size="pageSize"
          :disabled="isLoading"
          @current-change="pageChange"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import RestFormItem from '@/common/components/rest/RestFormItem'
import AddDataExtensionDialog from '@/modules/integrations/types/salesforce/AddDataExtensionDialog'
import DataExtensionMapping from '@/modules/integrations/types/salesforce/DataExtensionMapping'
import { EventBus } from '@/core/EventBus'
import { cloneDeep, unionBy } from 'lodash'
export default {
  name: 'MultipleMappingStep',

  components: {
    RestFormItem,
    DataExtensionMapping,
    AddDataExtensionDialog
  },

  props: {
    model: {
      type: Object
    }
  },

  data() {
    return {
      attributes: [],
      columns: [],
      filterableAttributes: [
        'email',
        'mobile_number',
        'whatsapp_number',
        'language',
        'timezone',
        'email_addressable',
        'email_subscription',
        'sms_addressable',
        'sms_subscription'
      ],
      isLoading: false,
      showDialog: false,
      pageSize: 10,
      currentPage: 1,
      paginatedExtensions: []
    }
  },

  created() {
    EventBus.$on('openDataExtensionsDialog', () => (this.showDialog = true))
    EventBus.$on('closeDataExtensionDialog', () => (this.showDialog = false))
    EventBus.$on('addDataExtension', extension =>
      this.appendExtension(extension)
    )
    this.updatePagination()
  },

  destroyed() {
    EventBus.$off('openDataExtensionsDialog')
    EventBus.$off('closeDataExtensionDialog')
    EventBus.$off('addDataExtension')
  },

  computed: {
    isUpdate() {
      return this.$route.query.hasOwnProperty('id')
    },
    pagination() {
      return this.model.params.enabledDataExtensions.length > this.pageSize
    },
    totalPages() {
      return Math.ceil(
        this.model.params.enabledDataExtensions.length / this.pageSize
      )
    }
  },

  methods: {
    addDataExtension() {
      this.showDialog = true
    },
    appendExtension(extension) {
      this.showDialog = false
      this.$set(
        this.model.params,
        'enabledDataExtensions',
        unionBy(
          this.model.params.enabledDataExtensions,
          [extension],
          'dataExtensionName'
        )
      )
      this.currentPage = this.totalPages
      this.updatePagination()
    },
    mappingChanged(values) {
      this.$set(
        this.model.params,
        'mapping',
        unionBy(values, this.model.params.mapping, 'fqn')
      )
    },
    removeDataExtension(extensionName) {
      if (
        this.model.params.enabledDataExtensions &&
        this.model.params.enabledDataExtensions.some(
          extension => extension.dataExtensionName === extensionName
        )
      ) {
        const newMapping = cloneDeep(this.model.params.mapping || [])
        this.model.params.mapping = newMapping.filter(
          a => !a.dataExtensionName || a.dataExtensionName !== extensionName
        )

        const newPrimaryKeys = cloneDeep(this.model.params.primaryKeys || [])
        this.model.params.primaryKeys = newPrimaryKeys.filter(
          a => !a.dataExtensionName || a.dataExtensionName !== extensionName
        )

        this.model.params.enabledDataExtensions.splice(
          this.model.params.enabledDataExtensions.findIndex(
            e => e.dataExtensionName === extensionName
          ),
          1
        )
        this.updatePagination()
      }
    },
    updatePagination() {
      if (this.model.params.enabledDataExtensions) {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        this.paginatedExtensions = this.model.params.enabledDataExtensions.slice(
          start,
          end
        )
      }
    },
    pageChange(page) {
      this.currentPage = page
      this.updatePagination()
    }
  }
}
</script>

<style scoped>
.DataExtensionsList__Empty {
  display: flex;
  flex-direction: column;
  gap: 10px;

  height: 30vh;
  min-height: 300px;

  align-items: center;
  justify-content: center;
}

.DataExtensionsList--Controls {
  display: flex;
  justify-content: end;

  margin-bottom: 20px;
}

.form-section {
  border: 1px solid #dbdee7;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  border-radius: 3px;
  margin-bottom: 20px;
}

.DataExtensionsListEmpty__Warning {
  font-size: 20px;
  padding: 0px 125px;
}

.paginator {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

>>> .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #1d87c8;
}

>>> .el-pagination.is-background .btn-prev,
>>> .el-pagination.is-background .btn-next,
>>> .el-pagination.is-background .el-pager li {
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/types/salesforce/MultipleMappingStep.vue